import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    styleUrls: ['./error-notification.component.less'],
    templateUrl: './error-notification.component.html',
})
export class ErrorNotificationComponent {

    public errors: string[];
    public errorId?: string;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {

    }

    ngOnInit() {
        this.errors = this.config.data.errors;
        this.errorId = this.config.data.errorId;
    }

    reloadWindow() {
        location.reload();
    }
}
